"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const gold_svg_1 = __importDefault(require("@components/icons/gold.svg"));
const rubin_svg_1 = __importDefault(require("@components/icons/rubin.svg"));
const almaz_svg_1 = __importDefault(require("@components/icons/almaz.svg"));
const styled_components_1 = __importDefault(require("styled-components"));
const ImagesWrapper = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    max-width: 130px;
    gap: 20px;
    align-items: center;
    justify-content: center;
    @media (max-width: 700px) {
        //max-height: 60px;
        flex-direction: row;
        display: flex;
        max-width: 100%;
        max-height: 70px;
        margin-left: 15px;
        gap: 10px;
    }
    @media (max-height: 684px) {
        gap: 50px;
    }
`;
const IconWrapper = styled_components_1.default.span `
    position: relative;
    display: flex;
    justify-content: center;
    max-width: 130px;
    width: 100%;
    align-items: flex-end;
    height: auto;
    flex-grow: 1;
    margin: 0 auto 20px auto;

    @media (max-width: 768px) {
        max-width: 100px;
    }
    
    @media (max-width: 700px) {
        margin: 0 auto;
        max-width: 70px;
        max-height: 70px;
        svg {
            width: 70px;
            height: 70px;
        }
    }

    @media (max-width: 520px) {
        max-width: 32px;
        max-height: 32px;
        svg {
            width: 32px;
            height: 32px;
        }
    }
`;
const IconQuantity = styled_components_1.default.span `
    position: absolute;
    padding: 8px;
    gap: 8px;
    border-radius: 90px;
    background: #FE2B45;
    background: ${(props) => props.bg};
    color: #FFFFFF;
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    font-family: inter;
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: -10%;
    @media (max-width: 700px) {
        margin: 0 auto;
        font-size: 16px;
        width: 70px;
        padding: 2px;

        //bottom: 0;
    }
    @media (max-width: 520px) {
        width: 32px;
        font-size: 8px;
        line-height: 1;
        bottom: -13%;
    }
`;
const QuantityGame = ({ goldCoin, rubyCount, diamondCount }) => {
    return (react_1.default.createElement(ImagesWrapper, null,
        react_1.default.createElement(IconWrapper, null,
            react_1.default.createElement(gold_svg_1.default, null),
            react_1.default.createElement(IconQuantity, { bg: "#F2A000" }, goldCoin)),
        react_1.default.createElement(IconWrapper, null,
            react_1.default.createElement(rubin_svg_1.default, null),
            react_1.default.createElement(IconQuantity, { bg: "#FE2B45" }, rubyCount)),
        react_1.default.createElement(IconWrapper, null,
            react_1.default.createElement(almaz_svg_1.default, null),
            react_1.default.createElement(IconQuantity, { bg: "#13A3EA" }, diamondCount))));
};
exports.default = QuantityGame;
